import { takeLatest, call, put } from 'redux-saga/effects'

import api from '../modules/api'
import * as actionTypes from '../modules/actions'
import { subscribeChatroomChannel } from '../websocket'

export function* chatroomWorkerFetchChatrooms(action) {
  try {
    const resp = yield call(api.fetchChatrooms)
    let chatrooms = []
    if (resp.status < 400 && resp.data.status === "success") {
      chatrooms = resp.data.chatrooms
    }

    yield put({
      type: actionTypes.SAVE_FETCHED_CHAT_ROOMS_TO_STORE,
      payload: chatrooms
    })

    if (chatrooms.length === 1) {
      const msgResp = yield call(api.fetchMessages, chatrooms[0].id, null)
      let messages = []
      if(msgResp.data.status === "success") {
        messages = msgResp.data.messages
        yield put({
          type: actionTypes.SAVE_FETCHED_MESSAGES_TO_STORE,
          payload: {
            messages,
            chatroomId: chatrooms[0].id,
          }
        })
      }
    }

    const chatroomIds = chatrooms.map(cr => cr.id)
    subscribeChatroomChannel(chatroomIds)
  } catch(error) {
  }
}

export function* chatroomWorkerFetchMessages(action) {
  try {
    const resp = yield call(api.fetchMessages, action.chatroomId, null)
    let messages = []
    if (resp.status < 400 && resp.data.status === "success") {
      messages = resp.data.messages
    }
    yield put({
      type: actionTypes.SAVE_FETCHED_MESSAGES_TO_STORE,
      payload: {
        messages,
        chatroomId: action.chatroomId
      }
    })
  } catch (error) {
  }
}

export function* chatroomWorkerLoadMoreMessages(action) {
  try {
    const {chatroomId, from} = action.payload
    const resp = yield call(api.fetchMessages, chatroomId, from)
    let messages = []
    if (resp.status < 400 && resp.data.status === "success") {
      messages = resp.data.messages
    }
    yield put({
      type: actionTypes.SAVE_LOADED_MESSAGES_TO_STORE,
      payload: {
        chatroomId,
        messages
      }
    })
  } catch (error) {
  }
}
export default [
  takeLatest(actionTypes.SAVE_FETCHED_CHAT_ROOMS_TO_STORE_REQUEST, chatroomWorkerFetchChatrooms),
  takeLatest(actionTypes.SAVE_FETCHED_MESSAGES_TO_STORE_REQUEST, chatroomWorkerFetchMessages),
  takeLatest(actionTypes.LOAD_MORE_MESSAGES_REQUEST, chatroomWorkerLoadMoreMessages)
]



// WEBPACK FOOTER //
// ./src/sagas/chatSagas.js